import f1 from 'assets/images/factions/f1.png';
import f2 from 'assets/images/factions/f2.png';
import f3 from 'assets/images/factions/f3.png';
import f4 from 'assets/images/factions/f4.png';
import f5 from 'assets/images/factions/f5.png';
import { useState } from 'react';
import { Fade } from 'react-awesome-reveal';


// ===== Factions =====
const Factions = () => {
    const [activeTab, setActiveTab] = useState("0");
    const descriptions = [
        {
            id: "0",
            title: "The Fedelions",
            typo: <Fade duration={1400}>
                <p>
                    <span style={{color: "#0086ff"}}>They are driven by discipline and respect.</span>
                    For generations they have been perfecting the art and techniques of combat.<br />
                    Today their fighting style is complete and mortal.
                    <br />
                    They would give everything for their fellow warriors and would serve their army to death. They always fight with honor above all, and don't really like the Oblivions (even tho they are brothers)
                </p>
            </Fade>
        },
        {
            id: "1",
            title: "The Flashars",
            typo: <Fade duration={1400}>
                <p>
                    <span style={{color: "#a2a2a2"}}>They are the fastest warriors.</span>
                    Due to the strong winds that hover over their planet,  the Flashars have developed extreme agility and speed. A legend tells that they can reach the speed of light. A speed that is sometimes hard to control.
                    <br />

                    They rarely travel alone. That's why they usually fight in packs/ a group of flashars is named flashgang .
                </p>
            </Fade>
        },
        {
            id: "2",
            title: "The An’heks ",
            typo: <Fade duration={1400}>
                <p>
                    <span style={{color: "#d07c27"}}>Their strength and endurance has no equal. </span>
                    Coming from a sandy planet, An’heks can spend days wandering in the desert.
                    This has pushed their tenacity and stamina/durability/ to the extreme. Today they are seen as the strongest warriors of all.
                    <br />

                    They are known to be solitary. This can be explained because they have the strength to defend themselves.

                </p>
            </Fade>
        },
        {
            id: "3",
            title: "The Royons",
            typo: <Fade duration={1400}>
                <p>
                    <span style={{color: "#cfb66e"}}>Other factions see them as superior and majestic. </span>
                    As the noble faction, the Royons shed light everywhere they go. They don't fight with their fists but with their brains. They are the finest strategists with a strong capacity to lead/govern. Thanks to their advanced technology, they built majestical/technologically advanced cities on their planet.
                    Their self-confidence, however great it may be, has never been a weakness, on the contrary it is a strength that they use to great effect.
                    <br />

                    Their substantial self-assurance was never seen as a weakness. On the contrary, they use it to get what they want.

                </p>
            </Fade>
        },
        {
            id: "4",
            title: "The Oblivions",
            typo: <>
                <p>
                    <span style={{color: "#ad4be0"}}>They master the art of stealth. </span>
                    They are known in the whole galaxy, although they are as discreet as possible. They could take anyone to hell in one shot with deadly accuracy. They have always evolved within a dark and hostile planet. Environmental conditions forced them to move silently and cautiously.
                    <br />
                    Despite their mischievous look, some say that they have a heart/feelings (they're robot so no heart). This remains to be proven.
                </p>
            </>
        },
    ];

    // 
    const findElem = (id) => {
        return descriptions?.find((v) => v?.id === id) || {}
    }
    return (
        <section id="factions">
            <div className="cs_container">
                <Fade direction='up' duration={1200} triggerOnce>
                    <>
                        <div className={`cs_row factions_row justify-content-center ${activeTab ? "anyone" : ""}`}>
                            <div title="Read more" role="button" onClick={() => setActiveTab((prev) => prev === "0" ? null : "0")} className={`faction-box ${activeTab === "0" ? "activeT" : ""}`}>
                                <img width="86" height="86" src={f1} alt="" />
                            </div>
                            <div title="Read more" role="button" onClick={() => setActiveTab((prev) => prev === "1" ? null : "1")} className={`faction-box ${activeTab === "1" ? "activeT" : ""}`}>
                                <img width="86" height="86" src={f2} alt="" />
                            </div>
                            <div title="Read more" role="button" onClick={() => setActiveTab((prev) => prev === "2" ? null : "2")} className={`faction-box ${activeTab === "2" ? "activeT" : ""}`}>
                                <img width="86" height="86" src={f3} alt="" />
                            </div>
                            <div title="Read more" role="button" onClick={() => setActiveTab((prev) => prev === "3" ? null : "3")} className={`faction-box ${activeTab === "3" ? "activeT" : ""}`}>
                                <img width="86" height="86" src={f4} alt="" />
                            </div>
                            <div title="Read more" role="button" onClick={() => setActiveTab((prev) => prev === "4" ? null : "4")} className={`faction-box ${activeTab === "4" ? "activeT" : ""}`}>
                                <img width="86" height="86" src={f5} alt="" />
                            </div>
                        </div>
                        <div className={`faction_about ${activeTab ? "active" : ""}`}>
                            <h4>
                            {findElem(activeTab)?.title}
                            </h4>
                            {findElem(activeTab)?.typo}
                        </div>
                    </>
                </Fade>
                <Fade direction='up' duration={1400} triggerOnce>
                    <h3 className='font_spaced'>which faction will you join?</h3>
                </Fade>
            </div>
        </section>
    )
}

export default Factions